export default "__VITE_ASSET__CT8Hl837__"